const accordionButtons = document.querySelectorAll('.accordion__button');

accordionButtons.forEach((button) => {
    button.addEventListener('click', ({ currentTarget }) => {
        if (currentTarget.classList.contains('active')) {
            currentTarget.classList.remove('active');
            currentTarget.setAttribute('aria-expanded', 'false');
            currentTarget.nextElementSibling.setAttribute('aria-hidden', 'true');
        } else {
            currentTarget.classList.add('active');
            currentTarget.setAttribute('aria-expanded', 'true');
            currentTarget.nextElementSibling.setAttribute('aria-hidden', 'false');
        }
    });
});
